
export default {

  // Calendar Labels
  eventLabels: [
    { text: 'حدث' , value : 'event', color: 'primary' },
    { text: 'إختبار', value: 'quiz', color: 'success'},
    { text: 'واجب', value: 'assignment', color: 'danger'},
  ],

  // Simple Calendar State
  events: []
}
